
import React, { useEffect } from "react";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from "@mui/material";

export const EditPermissionsDialog = ({ open, handleCancel, handleSubmit, permissionsOptions, existingPermissions, roleName }) => {
    const [selectedPermissions, setSelectedPermissions] = React.useState(existingPermissions)

    const closeAndClear = () => {
        setSelectedPermissions([])
        handleCancel()
    }

    const handlePermissionsChange = (_event, newValue) => {
        setSelectedPermissions(newValue)
    }

    useEffect(() => {
        setSelectedPermissions(existingPermissions)
    }, [existingPermissions])

    return (
        <Dialog
            open={open}
            onClose={closeAndClear}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        handleSubmit(roleName, selectedPermissions);
                        closeAndClear();
                    },
                },
            }}
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle>Edit Permissions</DialogTitle>
            <DialogContent>
                <FormControl fullWidth margin="normal">
                    <TextField
                        disabled
                        margin="dense"
                        id="roleName"
                        name="roleName"
                        label="Role Name"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={roleName}
                    />
                </FormControl>
                <FormControl fullWidth margin="normal">
                     <Autocomplete
                        id="edit-permissions-autocomplete"
                        multiple
                        options={permissionsOptions}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Permissions"
                                name="permissions"
                            />
                        )}
                        value={selectedPermissions}
                        onChange={handlePermissionsChange}
                    />
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={closeAndClear}>Cancel</Button>
                <Button type="submit">Submit</Button>
            </DialogActions>
        </Dialog>
    )
}
